var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-link', _vm._b({
    attrs: {
      "size": "sm",
      "variant": "flat-primary"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.onClick(e);
        }($event);
      }
    }
  }, 'b-link', [_vm.$attrs], false), [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }